<template>
  <div class="newsList" ref="container">
    <Tabs
      @click="onClick"
      class="newsSwitch"
      line-height="0.04rem"
      line-width="0.4rem"
      color="#e93323"
      v-model="active"
      animated
      title-inactive-color="2"
      nav-right="0.46rem"
      sticky
    >
      <Tab
        v-for="(item, index) in navList"
        :key="index"
        :title="item"
        title-inactive-color="#999"
        title-active-color="#282828"
      >
        <div class="list" v-for="(item, index) in Lists" :key="index">
          <div class="item">
            <router-link :to="{ path: '/feedback/detail/' + item.id }">
              <p class="title">
                {{ item.title }}
              </p>
              <p class="info">
                <img :src="item.avatar" :title="item.name" />
                <span class="brown">浏览：{{ item.brown }}</span
                >&nbsp;&nbsp;
                <span class="times">{{ item.add_time }}</span>
              </p>
            </router-link>
            <span class="del" v-if="type == 1" @click="del_list(index)"
              >撤销</span
            >
          </div>
        </div>
        <!----->
        <Loading
          :loaded="loadend"
          :loading="loading"
          v-if="index > 0 && Lists.length > 0"
        ></Loading>
        <!--暂无信息-->
        <div class="noCommodity" v-if="Lists.length === 0 && page > 1">
          <div class="van-empty">
            <div class="van-empty__image">
              <img src="@assets/images/empty-image-default.png" />
            </div>
            <p class="van-empty__description">暂无信息</p>
          </div>
        </div>
        <div class="loadend" v-if="loadend && Lists.length > 0">暂无更多~</div>
        <!----->
      </Tab>
    </Tabs>
    <Footer></Footer>
    <router-link :to="{ path: '/feedback/submit' }">
      <div class="submitInfo">
        <img src="@assets/images/edit.png" />
      </div>
    </router-link>
  </div>
</template>
<script>
import Footer from "@components/Footer";
import { getFeedBackList, delFeedBack } from "@api/public";
import { Tab, Tabs } from "vant";
import Loading from "@components/Loading";
export default {
  name: "List",
  components: {
    Tab,
    Tabs,
    Loading,
    Footer
  },
  data: function() {
    return {
      page: 1,
      active: 0,
      limit: 20,
      loading: false,
      loadend: false,
      loadTitle: "",
      Lists: [],
      navList: ["咨询", "我的"],
      type: 0
    };
  },
  mounted: function() {
    this.getLists();
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.getLists();
    });
  },
  watch: {
    // $route(n) {}
  },
  methods: {
    getLists: function() {
      let that = this;
      if (that.loading) return;
      if (that.loadend) return;
      that.loading = true;
      let q = {
        page: that.page,
        limit: that.limit,
        type: that.type
      };
      getFeedBackList(q).then(res => {
        that.loading = false;
        that.Lists.push.apply(that.Lists, res.data);
        that.loadend = res.data.length < that.limit;
        that.page = that.page + 1;
      });
      console.log(that);
    },
    onClick: function(value) {
      let obj = this;
      if (obj.type == value) {
        return false;
      } else {
        obj.type = value;
        obj.page = 1;
        obj.loadend = false;
        obj.loading = false;
        obj.Lists = [];
        obj.getLists();
      }
    },
    del_list: function(index) {
      let obj = this;
      let item = obj.Lists[index];
      obj.$dialog.confirm({
        mes: "温馨提醒：此操作不可逆，是否继续",
        opts: [
          {
            txt: "继续",
            color: false,
            callback: () => {
              delFeedBack({ id: item.id }).then(res => {
                if (res.status == 200) {
                  obj.Lists.splice(index, 1);
                  obj.$dialog.success(res.msg);
                } else {
                  obj.$dialog.error(res.msg);
                }
              });
            }
          },
          {
            txt: "取消",
            color: false,
            callback: () => {}
          }
        ]
      });
    }
  }
};
</script>
<style scoped>
.submitInfo {
  background-color: #f44939;
  width: 0.8rem;
  height: 0.8rem;
  border-radius: 50%;
  text-align: center;
  line-height: 1.05rem;
  position: fixed;
  bottom: 1.5rem;
  right: 0.1rem;
}
.submitInfo img {
  width: 0.45rem;
  height: 0.45rem;
}
.list .item .title {
  font-size: 0.3rem;
  color: #333;
  line-height: 0.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 3;
}
.list .item .info {
  margin-top: 0.1rem;
  height: 0.8rem;
  display: flex;
  align-items: center;
}
.list .item .info img {
  width: 0.7rem;
  border-radius: 50%;
}
.list .item .info .brown,
.times {
  color: #bbb;
  font-size: 0.2rem;
  margin-left: 0.1rem;
}
.list .item .del {
  font-size: 0.3rem;
  color: #f44336;
  float: right;
  position: relative;
  right: 0.5rem;
  bottom: 0.5rem;
}
.van-empty {
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 0.5rem 0;
}
.van-empty__image {
  height: 4rem;
  width: 4rem;
}
.van-empty__image img {
  width: 100%;
  height: 100%;
}
.van-empty__description {
  width: 100%;
  text-align: center;
  margin-top: 0.2rem;
  color: #9e9e9e;
  font-size: 0.3rem;
}
.loadend {
  line-height: 1rem;
  text-align: center;
  color: #bbb;
  font-size: 0.3rem;
}
</style>
